import { type ReactNode } from 'react';
import { Chip } from '@zep-us/zus';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizIndicatorChip - 힌트·채점 라벨 칩
 * @component
 */
export const QuizIndicatorChip = ({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) => <Chip size="sm" className={cn('rounded-xl border border-alternative px-xs py-3xs text-body-sm-semibold', className)} data-sentry-element="Chip" data-sentry-component="QuizIndicatorChip" data-sentry-source-file="QuizIndicatorChip.tsx">
    {children}
  </Chip>;